// ── Importaciones tal cual ──────────────────────────────
import React, { useState } from 'react';
import { Modal, Button, Container, Row, Col, ListGroup } from 'react-bootstrap';
import defaultImage from "../../assets/img/default.png";
import { NotificationsFetchAPI } from '../../api/Notifications';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { buildCloudinaryImageUrl } from '../utils/CloudinaryImageUrl';
import "./notification.css";


/* ── ICONS ── */
const IcoBell  = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const IcoX     = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoTrash = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6M14 11v6M9 6V4h6v2"/></svg>;
const IcoPlus  = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoStore = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcoCheck = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT 
════════════════════════════════════════════════════════ */
function ModalDetailNotification({ userBranchoffices, notification, setShowModal, showModal, setEventHandler, token }) {

  /* ════════════════════════════════════
     vARS
  ════════════════════════════════════ */
  const [showModalAsing, setShowModalAsing] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(0);

  const asignBranch = async () => {
    try {
      await NotificationsFetchAPI.asingBranchofficeToNotification(selectedBranch, notification.id, token);
      setEventHandler(1);
      setShowModalAsing(false);
      setShowModal(false);
      SuccessAlert('Sucursal asignada');
    } catch (err) {
      if (err.response.data.error) {
        ErrorAlert(err.response.data.error, "Error", "warning");
      } else {
        ErrorAlert('Error al asignar la sucursal', "Error", "error");
      }
    }
  };

  const removeBranch = async (branchoffice_id) => {
    try {
      await NotificationsFetchAPI.removeBranchofficeToNotification(branchoffice_id, notification.id, token);
      setEventHandler(1);
      setShowModalAsing(false);
      setShowModal(false);
      SuccessAlert('Sucursal removida');
    } catch (err) {
      if (err.response.data.error) {
        ErrorAlert(err.response.data.error, "Error", "warning");
      } else {
        ErrorAlert('Error al remover la sucursal', "Error", "error");
      }
    }
  };
  /* ════════════════════════════════════
   End
  ════════════════════════════════════ */

  return (
    <>
      {/* ══════════════════════════════════════════
          MODAL PRINCIPAL — detalle de notificación
      ══════════════════════════════════════════ */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        dialogClassName="mdn-dialog"
      >
        <Modal.Header className="text-center">
          <h3><i className="uil uil-eye" /> Detalle de la notificación</h3>
        </Modal.Header>
        <Modal.Body>

          {/* header visual */}
          <div className="mdn-head">
            <div className="mdn-head-ico"><IcoBell /></div>
            <div>
              <div className="mdn-head-title">Detalle de notificación</div>
              <div className="mdn-head-sub">{notification.name || 'Sin nombre'}</div>
            </div>
            <button className="mdn-close" type="button" onClick={() => setShowModal(false)}>
              <IcoX />
            </button>
          </div>

          {/* imagen — lógica original intacta */}
          <div className="mdn-img-wrap">
            <img
              className="mdn-img imgEditModal"
              loading="lazy"
              src={
                notification.secure_url
                  ? buildCloudinaryImageUrl({ url: notification.secure_url, width: 600, quality: "auto", type: "image" })
                  : defaultImage
              }
              alt=""
            />
          </div>

          {/* body: info + sucursales */}
          <div className="mdn-body">

            {/* columna izquierda: info general */}
            <div>
              <div className="mdn-section-title">Información general</div>

              <div className="mdn-info-row">
                <div className="mdn-info-label">Nombre</div>
                <div className="mdn-info-value">{notification.name}</div>
              </div>

              <div className="mdn-info-row">
                <div className="mdn-info-label">Descripción</div>
                <div className="mdn-info-value">{notification.description}</div>
              </div>
            </div>

            {/* columna derecha: sucursales */}
            <div>
              <div className="mdn-section-title">
                Sucursales
                <button className="mdn-btn-assign" onClick={() => setShowModalAsing(true)}>
                  <IcoPlus /> Asignar
                </button>
              </div>

              <div className="mdn-branches">
                {notification.branchoffices?.length > 0 ? (
                  notification.branchoffices.map((branch, i) => (
                    <div className="mdn-branch-row" key={branch.branchoffice_id} style={{ animationDelay: `${i * 0.05}s` }}>
                      <span className="mdn-branch-name">{branch.name}</span>
                      {/* removeBranch — lógica original intacta */}
                      <button className="mdn-btn-remove" onClick={() => removeBranch(branch.branchoffice_id)}>
                        <IcoTrash />
                      </button>
                    </div>
                  ))
                ) : (
                  <span className="mdn-empty-branches">Sin sucursales asignadas</span>
                )}
              </div>
            </div>
          </div>

          {/* footer */}
          <div className="mdn-footer">
            <button className="mdn-btn-close" type="button" onClick={() => setShowModal(false)}>
              Cerrar
            </button>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* ══════════════════════════════════════════
          MODAL ASIGNAR SUCURSAL
      ══════════════════════════════════════════ */}
      <Modal
        show={showModalAsing}
        onHide={() => setShowModalAsing(false)}
        size="large"
        centered
        dialogClassName="mdn-assign-dialog"
      >
        <Modal.Header>
          <h3><i className="uil uil-plus"/> Asignar Sucursal</h3>
        </Modal.Header>
        <Modal.Body>

          {/* header visual */}
          <div className="mdn-assign-head">
            <div className="mdn-assign-ico"><IcoStore /></div>
            <div className="mdn-assign-title">Asignar sucursal</div>
            <button className="mdn-close" type="button" onClick={() => setShowModalAsing(false)}>
              <IcoX />
            </button>
          </div>

          <div className="mdn-assign-body">
            <div>
              <label style={{ fontSize: '.76rem', fontWeight: 600, color: '#6B7280', marginBottom: '.3rem', display: 'block', fontFamily: 'var(--font-sans,-apple-system,sans-serif)' }}>
                Sucursal
              </label>
              {/* select — lógica original intacta */}
              <select
                className="mdn-select form-select"
                name="branchoffice_id"
                id="branchoffice_id"
                onChange={e => setSelectedBranch(e.target.value)}
              >
                <option>Seleccione una sucursal</option>
                {userBranchoffices.map(branchoffice => (
                  <option key={branchoffice.branchoffice_id} value={branchoffice.branchoffice_id}>
                    {branchoffice.branchoffice_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mdn-assign-footer">
            <button className="mdn-btn-close" type="button" onClick={() => setShowModalAsing(false)}>
              Cancelar
            </button>
            {/* asignBranch — lógica original intacta */}
            <button className="mdn-btn-save" type="button" onClick={() => asignBranch()}>
              <IcoCheck /> Guardar
            </button>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModalAsing(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* Bootstrap originales preservados — Container, Row, Col, ListGroup ── */}
      <div style={{ display: 'none' }}>
        <Container><Row><Col>
          <ListGroup as="ol">
            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
              <div className="ms-2 me-auto"><div className="fw-bold">x</div></div>
            </ListGroup.Item>
          </ListGroup>
          <Button size="sm" variant="success" type="button">x</Button>
        </Col></Row></Container>
      </div>
    </>
  );
}

export default ModalDetailNotification;